import Vue from 'vue'
import App from './index/App.vue'
import router from './index/router'
// import LANG from '../config/env.config'
const LANG = require('../config/env.config');

Vue.config.productionTip = false

new Vue({
  router,
  LANG,
  render: h => h(App)
}).$mount('#app')
